import React, { useState } from "react";
import styles from "./style.module.css";
import Button from "../Buttons";
import Card from "../Card";
import HandFingerIcon from "../../../../assets/images/HandFingerIcon.png";
import KycIcon from "../../../../assets/images/KycIcon.png";
import AgreementIcon from "../../../../assets/images/AgreementIcon.png";
import SearchPropertyIcon from "../../../../assets/images/SearchPropertyIcon.png";
import ProfileIcon from "../../../../assets/images/ProfileIcon.png";
import CheckInIcon from "../../../../assets/images/CheckInIcon.png";
import financesIcon1 from "../../../../assets/images/financesIcon1.png";
import financesIcon2 from "../../../../assets/images/financesIcon2.png";
import financesIcon3 from "../../../../assets/images/financesIcon3.png";
import financesIcon4 from "../../../../assets/images/financesIcon4.png";
import financesIcon5 from "../../../../assets/images/financesIcon5.png";
import managementIcon1 from "../../../../assets/images/managementIcon1.png";
import managementIcon2 from "../../../../assets/images/managementIcon2.png";
import managementIcon3 from "../../../../assets/images/managementIcon3.png";
import managementIcon4 from "../../../../assets/images/managementIcon4.png";
import managementIcon6 from "../../../../assets/images/managementIcon6.png";

const Section = () => {
  const [activeButton, setActiveButton] = useState("operations");

  const cardsData = [
    {
      title: "Onboarding",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "operations",
      icon: ProfileIcon,
    },
    {
      title: "Digital KYC",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "operations",
      icon: KycIcon,
    },
    {
      title: "Digital rental agreement",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "operations",
      icon: AgreementIcon,
    },
    {
      title: "Property listing",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "operations",
      icon: SearchPropertyIcon,
    },
    {
      title: "Online leads and bookings",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "operations",
      icon: HandFingerIcon,
    },
    {
      title: "Digital check-in",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "operations",
      icon: CheckInIcon,
    },

    {
      title: "Automated Payments",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "finances",
      icon: financesIcon1,
    },
    {
      title: "Payment Reminders",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "finances",
      icon: financesIcon2,
    },
    {
      title: "Automated Receipt",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "finances",
      icon: financesIcon3,
    },
    {
      title: "Rent Collection",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "finances",
      icon: financesIcon4,
    },
    {
      title: "Financial Analytics",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "finances",
      icon: financesIcon5,
    },
    {
      title: "Sales Management",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "management",
      icon: managementIcon1,
    },
    {
      title: "Complaint Management",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "management",
      icon: managementIcon2,
    },
    {
      title: "Inventory Management",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "management",
      icon: managementIcon3,
    },
    {
      title: "Enquiries dashboard",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "management",
      icon: managementIcon4,
    },
    {
      title: "Analytics dashboard",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "management",
      icon: financesIcon5,
    },
    {
      title: "Complaint assignment and progress",
      description:
        "Elevate your rental property endeavors with our advanced SaaS digital infrastructure, synchronizing operations, finances, and management effortlessly",
      category: "management",
      icon: managementIcon6,
    },
  ];

  // const icon = [
  //   {icon: ProfileIcon },
  //   {icon: KycIcon },
  //   {icon: AgreementIcon },
  //   {icon: SearchPropertyIcon },
  //   {icon: HandFingerIcon },
  //   {icon: CheckInIcon },
  // ]

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  const filteredCards = cardsData.filter(
    (card) => card.category === activeButton
  );

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <h3 className={styles.heading}>
          We <span className={styles.span}>tailored the unique solution</span>{" "}
          for the landlords
        </h3>
        <div className={styles.miniSection}>
          <div className={styles.buttonsContainer}>
            <Button
              active={activeButton === "operations"}
              onClick={() => handleButtonClick("operations")}
              text="operations"
            />
            <Button
              active={activeButton === "finances"}
              onClick={() => handleButtonClick("finances")}
              text="finances"
            />
            <Button
              active={activeButton === "management"}
              onClick={() => handleButtonClick("management")}
              text="management"
            />
          </div>

          <div className={styles.listItem}>
            <div className={styles.cardGrid}>
              {filteredCards.map((card, index) => (
                <Card
                  key={index}
                  title={card.title}
                  description={card.description}
                  icon={card.icon}
                  index={index}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section;
